export default __webpack_public_path__ + "images/3beddc0aa037b0b4825bfc2e97840cd1.png";